import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Signup = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'signup' */
  './Signup'
))

export function AsyncSignup(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Signup..." />}>
      <Signup {...props} />
    </Suspense>
  )
}

export default AsyncSignup
